import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';


const NotificationActions = {

    showNotification: function (notification, timeout = 3900) {
        AppDispatcher.dispatch({
            notification,
            actionType: ActionTypes.NOTIFICATION_SHOW
        });

        _.delay(this.hideNotification, timeout, notification);
    },

    hideNotification (notification = null) {
        AppDispatcher.dispatch({
            notification,
            actionType: ActionTypes.NOTIFICATION_HIDE
        });
    }

};


export default NotificationActions;



// WEBPACK FOOTER //
// ./src/actions/NotificationActions.js